"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.replaceConfigTemplates = exports.getConfigFilePath = void 0;
const object_hash_1 = __importDefault(require("object-hash"));
const path_1 = __importDefault(require("path"));
const lodash_functions_1 = require("../util/lodash-functions");
const types_1 = require("@refinitiv-data/types");
/**
 * Returns full path to config file
 * For example - /home/user/config_folder/rdplibconfig.json - for NodeJS
 * /rdplibconfig.json - for a browser
 * @param {string} env Value of env variable RDPLIB_ENV
 * @param {string} dir Folder contains configuration files
 * @param {string} ext Config file extension (json,....)
 */
function getConfigFilePath(env = types_1.DEFAULT_CONFIG_PLATFORM, dir = types_1.DEFAULT_CONFIG_DIR, ext = types_1.DEFAULT_CONFIG_FILE_EXTENSION) {
    const fileName = `${types_1.DEFAULT_CONFIG_FILE_NAME}.${env}.${ext}`;
    return path_1.default.resolve(dir, fileName);
}
exports.getConfigFilePath = getConfigFilePath;
/**
 * Returns JSON with replaced string templates to appropriate values
 * If there are multiple references from template-to-template
 * file will be parsed recursively until all possible templates will be resolved
 * In case a template can't be resolved or does not exist - it leaves as is as string
 * @param {string} jsonAsString Source to be analyzed for replacing
 * @param {RegExp} search Regex to search for in the source file
 */
function replaceConfigTemplates(jsonAsString, search = types_1.CONFIG_TEMPLATE_TO_REPLACE) {
    const jsonContent = JSON.parse(jsonAsString);
    const withReplacedEnv = replaceTemplateValuesFromEnv(jsonAsString, search);
    const replacedTemplates = replaceTemplateValuesFromFile(withReplacedEnv, search);
    const result = JSON.parse(replacedTemplates);
    if ((0, object_hash_1.default)(jsonContent) !== (0, object_hash_1.default)(result)) {
        return replaceConfigTemplates(replacedTemplates, search);
    }
    return result;
}
exports.replaceConfigTemplates = replaceConfigTemplates;
/**
 * Search for all templates meeting the condition in Map
 * Returns the template as key and parsed paths to array of string as value
 * ${source:name:first} => ['source', 'name', 'first']
 * @param {string} source JSON file as a string
 * @param {Regex} regex Regex to find all the templates within the JSON file
 */
function getMatches(source, regex) {
    const result = new Map();
    let match;
    do {
        match = regex.exec(source);
        if (match) {
            result.set(match[0], match[1].split(types_1.CONFIG_TEMPLATE_DIVIDER));
        }
    } while (match);
    return result;
}
/**
 * Search for values inside the same JSON by passed paths
 * Returns a Map with template and value to replace this template within the JSON
 * {'${service:endpoint}' => 'http://hello.world'}
 * @param {string} source Config file content to replace templates with values
 * @param {RegExp} regex Regular expression to find a template(s) in the file
 */
function replaceTemplateValuesFromFile(source, regex) {
    const templateValues = new Map();
    const sourceAsJson = JSON.parse(source);
    const templatesMap = getMatches(source, regex);
    for (const [template, templatePath] of templatesMap) {
        const value = (0, lodash_functions_1.pick)(sourceAsJson, templatePath);
        if (value && !(0, lodash_functions_1.isUndefined)((0, lodash_functions_1.get)(value, templatePath))) {
            const setValue = (0, lodash_functions_1.get)(value, templatePath);
            const isObjectValue = (0, lodash_functions_1.isPlainObject)(setValue);
            const templateToReplace = isObjectValue ? `"${template}"` : template;
            const valueToReplace = isObjectValue ? JSON.stringify(setValue) : setValue;
            templateValues.set(templateToReplace, valueToReplace);
        }
        else {
            templateValues.set(template, template);
        }
    }
    let result = source;
    templateValues.forEach((value, template) => {
        result = result.replace(template, value);
    });
    return result;
}
/**
 * Search for the template values in environment variables
 * The ENV variables have a higher priority than JSON file configurations
 * Returns a string with replaced values from ENV
 * {'${RDP_URL}' => 'http://hello.world'}
 * @param {string} source Source file as string
 * @param {RegExp} regex Regular expression to find a template(s) in the file
 */
function replaceTemplateValuesFromEnv(source, regex) {
    const templates = getMatches(source, regex);
    let result = source;
    for (const [template, paths] of templates) {
        const envName = paths.join(types_1.CONFIG_TEMPLATE_DIVIDER);
        const value = process.env[envName];
        if (value !== undefined) {
            result = result.replace(template, value);
        }
    }
    return result;
}
//# sourceMappingURL=data:application/json;base64,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